import { axiosClient } from 'api/api';

export type ManagedUserHistory = { historyList: import('components/History/History.interface').Participant[]; totalUsers: number; totalPages: number };
export async function getManagedUserHistory(id: number, page: number): Promise<ManagedUserHistory> {
  return (await axiosClient.get(`/api/admin/users/${id}/survey-history`, { params: { page } })).data.result;
}

export type ManagedUser = {
  id: number;
  username: string;
  name: string;
  email: string;
  panelistId: number | null;
  country: string;
  registeredAt: string;
  role: number;
  isActive: number;
  isSubscribed: number;
  points: number | string;
};
export type UserSortKey = 'id' | 'member' | 'username' | 'registeredAt' | 'points' | 'isActive' | 'isSubscribed';
export async function listManagedUsers(page: number, search: string, sortBy: UserSortKey = 'id', sortOrder: 'asc' | 'desc' = 'desc'): Promise<{ users: ManagedUser[]; hasMore: boolean }> {
  return (await axiosClient.get('/api/admin/users', { params: { page, search, sortBy, sortOrder } })).data.result;
}
export async function updateManagedUser(id: number, field: 'isActive' | 'isSubscribed', value: number): Promise<ManagedUser> {
  return (await axiosClient.patch(`/api/admin/users/${id}`, { [field]: value })).data.result;
}
export async function deleteManagedUser(id: number): Promise<void> {
  await axiosClient.delete(`/api/admin/users/${id}`);
}
